export var WebsiteURL;
(function (WebsiteURL) {
    WebsiteURL["ABOUT_US"] = "ABOUT_US";
    WebsiteURL["TERMS"] = "TERMS";
    WebsiteURL["PRIVACY"] = "PRIVACY";
    WebsiteURL["TEFCA_NOTICE"] = "TEFCA_NOTICE";
    WebsiteURL["CONTACT_US"] = "CONTACT_US";
    WebsiteURL["FAQ"] = "FAQ";
    WebsiteURL["HOW_HEALTHEX_MANAGES_DATA"] = "HOW_HEALTHEX_MANAGES_DATA";
    WebsiteURL["FEEDBACK"] = "FEEDBACK";
    WebsiteURL["SUPPORT"] = "SUPPORT";
    WebsiteURL["LEGAL"] = "LEGAL";
})(WebsiteURL || (WebsiteURL = {}));
export function buildWebsiteUrl(link, domain, language) {
    let path;
    switch (link) {
        case WebsiteURL.ABOUT_US:
            path = "about-us";
            break;
        case WebsiteURL.TERMS:
            path = "terms-of-service";
            break;
        case WebsiteURL.PRIVACY:
            path = "privacy-policy";
            break;
        case WebsiteURL.TEFCA_NOTICE:
            path = "tefca-privacy-and-security-notice";
            break;
        case WebsiteURL.CONTACT_US:
            path = "contact-us";
            break;
        case WebsiteURL.FAQ:
            path = "faqs";
            break;
        case WebsiteURL.HOW_HEALTHEX_MANAGES_DATA:
            path = "privacy-policy";
            break;
        case WebsiteURL.FEEDBACK:
            path = "support";
            break;
        case WebsiteURL.SUPPORT:
            path = "support";
            break;
        case WebsiteURL.LEGAL:
            path = "legal";
            break;
    }
    const languagePath = "";
    const scheme = domain.includes("://") ? "" : "https://";
    const url = `${scheme}${domain}/${languagePath}${path}`;
    return url;
}
